import { useState, useEffect } from 'react';
import { fetchWithAuth } from './authHelpers';

export const useUserNames = () => {
    const [userNames, setUserNames] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserNames = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/users/names`, 'GET');
                if (!response.ok) {
                    throw new Error('Failed to fetch user names');
                }
                const data = await response.json();
                setError(null);
                setUserNames(data);
            } catch (error) {
                console.error('Error fetching user names');
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchUserNames();
    }, []);

    return { userNames, loading, error };
};